module.exports = __webpack_public_path__ + "static/img/invite-side-img.f7c5f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite-side-img.png
// module id = 6E+q
// module chunks = 1